<!-- 商品配置 -->
<template>
  <div class='content'>
    <el-form ref="form" label-width="auto" align="left" :inline="true">
      <el-form-item label="商品名称：">
        <el-input placeholder="输入商品名称" @change="getTableList()" v-model="params.productName"></el-input>
      </el-form-item>
      <el-form-item label="商品分类：">
        <el-select v-model="params.productType">
          <el-option value="" label="全部"></el-option>
          <el-option v-for="item in productTypeList" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="getTableList()">搜索</el-button>
        <el-button size="small" @click="resetParams();getTableList();">重置</el-button>
        <el-button size="small" type="primary" @click="title='新增商品';resetForm();dialogVisible=true">新增商品</el-button>
      </el-form-item>
    </el-form>

    <el-table 
      :data="tableData"
      class="mt-20"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}">
      <!-- show-overflow-tooltip -->
      <el-table-column label="商品ID" prop="productId"></el-table-column>
      <el-table-column label="商品名称" prop="productName"></el-table-column>
      <el-table-column label="数值" prop="productValueStr"></el-table-column>
      <el-table-column label="图片" prop="productIcon">
        <template slot-scope="scope">
          <el-image 
            style="width: 50px; height: 50px"
            :src="scope.row.productIcon|getImgUrl" 
            :preview-src-list="[cache.fetchOssPath() || 'https://img.91cdkey.com/'+scope.row.productIcon]">
          </el-image>
        </template>
      </el-table-column>
      <el-table-column label="商品分类" prop="dealTime">
        <template slot-scope="scope">{{ scope.row.productType|productTypeFilters }}</template>
      </el-table-column>
      <el-table-column label="游戏任务发放数" prop="taskRewardNum"></el-table-column>
      <el-table-column label="福利抽奖发放数" prop="lotteryRewardNum"></el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button 
            type="text" 
            size="small" 
            @click="editGoods(scope.row.productId)">编辑</el-button>
          <el-button 
            type="text" 
            size="small" 
            @click="deleteGoods(scope.row.productId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-row class="mt-15 mr-20 text-right" v-if="total > 0">
      <el-pagination 
        small layout="total,prev,pager, next,sizes,jumper" 
        :page-size="params.pageSize"
        :total="total" 
        :current-page.sync="params.pageNum" 
        :page-sizes="[10 ,20 , 30, 40, 50]"
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-row>

    <!-- 新增/编辑商品 -->
    <el-dialog :title="title" :visible.sync="dialogVisible"> 
      <el-form :model="form" ref="form" label-width="auto">
        <el-form-item label="商品名称：" required>
          <el-input type="text" v-model="form.productName" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item  required>
          <template #label>
            <span class="label-with-break">
              图片：<br>
              (272*180px)
            </span>
          </template>
          <ImageUpload :url="form.productIcon" @image-uploaded="form.productIcon = $event" />
        </el-form-item>
        <el-form-item label="分类：" required>
          <el-select v-model="form.productType">
            <el-option v-for="item in productTypeList" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数值：" v-if="form.productType!=1 && form.productType!=5 && form.productType!=6" required>
          <el-input type="text" v-model="form.productValue" placeholder="请输入数值"></el-input>
        </el-form-item>
        <el-form-item label="使用地址：" v-if="form.productType==1" required>
          <el-input type="text" v-model="form.cdkeyUrl" placeholder="请输入使用地址"></el-input>
        </el-form-item>
        <el-form-item label="二维码呈现：" v-if="form.productType==1" required>
          <el-radio-group v-model="form.showQrcode">
            <el-radio label="0">否</el-radio>
            <el-radio label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="使用说明：" v-if="form.productType==1" required>
          <vue-ueditor-wrap v-model="form.cdkeyDesc" :config="myConfig"></vue-ueditor-wrap>
        </el-form-item>
        <el-form-item label="游戏ID：" v-if="form.productType==5" required>
          <el-input type="text" v-model="form.gameId" placeholder="请输入game_id"></el-input>
        </el-form-item>
        <el-form-item label="活动ID：" v-if="form.productType==5" required>
          <el-input type="text" v-model="form.actId" placeholder="请输入act_id"></el-input>
        </el-form-item>
        <el-form-item label="流程ID：" v-if="form.productType==5" required>
          <el-input type="text" v-model="form.flowId" placeholder="请输入flow_id"></el-input>
        </el-form-item>
        <el-form-item label="奖品类型：" v-if="form.productType==6" required>
          <el-radio-group v-model="form.fucaiType">
            <el-radio label="1">彩票券</el-radio>
            <el-radio label="2">加油加速器</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <el-row class="mt-20"> <!-- 移除外层 text-right，让两个 col 分别控制对齐 -->
        <!-- 文字列：占14份（可调整），居中对齐，顶部内边距垂直居中 -->
        <!-- <el-col :span="14" class="text-center pt-5">
          <span class="text-danger"  style="color: #F56C6C; font-size:22px;font-weight: 600;">支付宝红包, 10000数值=1元</span>
        </el-col> -->
        
        <!-- 按钮列：占10份（24-14=10），右对齐，按钮自然排列 -->
        <el-col  class="text-right">
          <el-button @click="resetForm();title='';dialogVisible=false">取消</el-button>
          <el-button type="primary" :loading="buttonLoading" @click="confirm()">确定</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
 
<script>
  import VueUeditorWrap from 'vue-ueditor-wrap';
  export default {
    components:{VueUeditorWrap},
    data() {
      //这里存放数据
      return {
        params:{
          productName: '',
          productType: '',
          pageNum: 1,
          pageSize: 10
        },
        total: 0,
        tableData:[],
        productTypeList:[],
        title: '新增商品',
        dialogVisible: false,
        form:{ 
          productId: null,
          productName: '',
          productValue: '',
          productIcon: '',
          productType: '',
          cdkeyUrl: '',
          showQrcode: '',
          cdkeyDesc: '',
          gameId: '',
          actId: '',
          flowId: '',
          fucaiType: '',
          productValueStr: ''
        },
        buttonLoading: false,
        myConfig: {
          // 编辑器不自动被内容撑高
          autoHeightEnabled: false,
          // 初始容器高度
          initialFrameHeight: 240,
          // 初始容器宽度
          initialFrameWidth: '100%',
          // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
          //serverUrl: 'http://35.201.165.105:8000/controller.php',
          serverUrl: this.ajax.baseUrl + 'oss/editorResources',
          // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
          UEDITOR_HOME_URL: '/static/UEditor/'
        },
      };
    },
    filters:{
      productTypeFilters(status){
        switch (status) {
          case 0:
            return '积分';
          case 1:
            return 'cdkey';
          case 2:
            return '微信红包';
          case 3:
            return '支付宝红包';
          case 4:
            return '实物';
          case 5:
            return 'livelink';
          case 6:
            return '99权益';
          default:
            break;
        }
      }
    },
    //方法集合
    methods: {
      /**获取列表数据 */
      getTableList(){
        this.ajax.fetch({
          url: this.apis.goodsManage.get,
          disableLoading: true,
          method: 'post',
          param: this.params,
          successFunc: res=>{
            this.total = res.total;
            this.tableData = res.result;
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      getProductType(){
        this.ajax.fetch({
          url: this.apis.goodsManage.getProductType,
          disableLoading: true,
          method: 'post',
          successFunc: res=>{
            this.productTypeList = this.Utils.objectToArray(res);
          },
          errorFunc: err=>{
            console.log(err);
          }
        });
      },
      editGoods(productId){
        this.resetForm();
        this.ajax.fetch({
          url: this.apis.goodsManage.getProductDetail,
          disableLoading: true,
          method: 'post',
          param: {productId:productId},
          successFunc: res=>{
            this.form.productId = res.product.productId;
            this.form.productName = res.product.productName;
            this.form.productIcon = res.product.productIcon;
            this.form.productType = String(res.product.productType);
            if (this.form.productType==1) {
              this.form.cdkeyUrl = res.cdkey.cdkeyUrl;
              this.form.showQrcode = String(res.cdkey.showQrcode);
              this.form.cdkeyDesc = res.cdkey.cdkeyDesc;
            } else if (this.form.productType==5) {
              this.form.gameId = res.livelink ? res.livelink.gameId : '';
              this.form.actId = res.livelink ? res.livelink.actId : '';
              this.form.flowId = res.livelink ? res.livelink.flowId : '';
            } else if (this.form.productType==6) {
              this.form.fucaiType = res.fucai && res.fucai.fucaiType != null ? String(res.fucai.fucaiType) : '';
            }else{
              this.form.productValue = res.product.productValueStr;
            }
            this.title = '编辑商品';
            this.dialogVisible = true;
          },
          errorFunc: err=>{
            console.log(err);
          }
        });
      },
      /**删除商品 */
      deleteGoods(productId){
        this.$confirm('删除后无法恢复,确定删除该项?', '确认删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          let obj = { productId: productId };
          this.ajax.fetch({
            url: this.apis.goodsManage.delete,
            disableLoading: true,
            method: 'post',
            param: obj,
            successFunc: res=>{
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getTableList();
            },
            errorFunc: err=>{
              console.log(err);
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
      confirm(){
        if (!this.form.productName) return this.$message('请输入商品名称');
        if (!this.form.productIcon) return this.$message('请上传图片');
        if (!this.form.productType) return this.$message('请选择分类');
        if (this.form.productType==1) {
          if (!this.form.cdkeyUrl) return this.$message('请输入使用地址');
          if (!this.form.showQrcode) return this.$message('请选择是否二维码呈现');
          if (!this.form.cdkeyDesc) return this.$message('请输入使用说明');
        } else if (this.form.productType==5) {
          if (!this.form.gameId) return this.$message('请输入游戏ID');
          if (!this.form.actId) return this.$message('请输入活动ID');
          if (!this.form.flowId) return this.$message('请输入流程ID');
        } else if (this.form.productType==6) {
          if (!this.form.fucaiType) return this.$message('请选择奖品类型');
        }else{
          if (!this.form.productValue) return this.$message('请输入数值');
        }
        if (this.form.productId == null) {
          this.ajax.fetch({
            url: this.apis.goodsManage.add,
            disableLoading: true,
            method: 'post',
            param: this.form,
            successFunc: res=>{
              this.$message.success('新增成功!');
              this.dialogVisible = false;
              this.resetForm();
              this.getTableList();
            },
            errorFunc: err=>{
              this.$message.error(err.info);
            }
          });
        }else{
          this.ajax.fetch({
            url: this.apis.goodsManage.update,
            disableLoading: true,
            method: 'post',
            param: this.form,
            successFunc: res=>{
              this.$message.success('编辑成功!');
              this.dialogVisible = false;
              this.resetForm();
              this.getTableList();
            },
            errorFunc: err=>{
              this.$message.error(err.info);
            }
          });
        }
      },
      resetParams(){
        this.params={
          productName: '',
          productType: '',
          pageNum: 1,
          pageSize: 10
        }
      },
      resetForm(){
        this.form={ 
          productId: null,
          productName: '',
          productValue: '',
          productIcon: '',
          productType: '',
          cdkeyUrl: '',
          showQrcode: '',
          cdkeyDesc: '',
          gameId: '',
          actId: '',
          flowId: '',
          fucaiType: ''
        }
      },
      handleSizeChange(page) {
        this.params.pageSize = page;
        this.getTableList();
      },
      handleCurrentChange(val){
        this.params.pageNum = val;
        this.getTableList();
      },
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.getProductType();
      this.getTableList();
    },
  }
</script>

<style lang='scss' scoped>

</style>



// WEBPACK FOOTER //
// src/page/productsManage/goodsList/goodsList.vue